import { useCallback } from 'react';

import { openAsyncLink } from '../../helpers';

import { useGetFileLinkDownload } from './useGetFileLinkDownload';

export const useDownloadFile = () => {
  const { getFileLink, loading } = useGetFileLinkDownload();

  const handleDownloadFile = useCallback(
    async (fileId: string) => {
      openAsyncLink(() => getFileLink(fileId));
    },
    [getFileLink]
  );

  return {
    downloadFile: handleDownloadFile,
    loading,
  };
};
